import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { DataPromise } from '../../context/AxiosContext'
import Loading from '../../components/Loading'
import AttributesList from '../../components/Form/Attributes/AttributesList'
import useViewport, { Viewport } from '../../hooks/useViewport'
import {
    AttributeContextType,
    AttributeDefinitionDto,
    AttributeEntityDto,
    AttributeViewType,
    EntityAttributeType,
} from '../../hooks/useAttributes'
import { makeStyles, tokens } from '@fluentui/react-components'
import { mergeStyles } from '@fluentui/react'

type Props = {
    entity: DataPromise<AttributeEntityDto>
    attributeDefinitions?: AttributeDefinitionDto[]
    category: string
}

const useStyles = makeStyles({
    container: {
        display: 'grid',
        margin: tokens.spacingHorizontalM,
    },
    containerSmall: {
        maxWidth: '66%',
    },
})

export default function AttributesOverview(props: Props): ReactElement {
    const { isViewport, viewport } = useViewport()
    const orientation = useMemo(() => (isViewport('<', Viewport.XL) ? 'vertical' : 'horizontal'), [viewport])
    const styles = useStyles()

    const entityData = useMemo(() => (props.entity.loaded ? props.entity.data : undefined), [props.entity.loaded])

    if (!props.entity.loaded) {
        return <Loading />
    }

    return (
        <div
            className={
                orientation === 'horizontal' ? mergeStyles(styles.container, styles.containerSmall) : styles.container
            }
        >
            <AttributesList
                attributeDefinitions={props.attributeDefinitions}
                orientation={orientation}
                entity={entityData}
                entityType={EntityAttributeType.File}
                context={[AttributeContextType.File]}
                viewType={AttributeViewType.View}
                category={props.category}
            />
        </div>
    )
}
